import { t } from "@shared/utils/i18n";

/** POST /manage/warehouseProductMatch/logList → data.items[] */
export interface ProductPairingLogSnapshotApi {
    matchQty?: string;
    productId?: string;
    warehousesSkuId?: number | string;
    warehouseSkuId?: string;
    /** 接口字段 skulp / sku1p */
    skulp?: string;
    sku1p?: string;
    asins?: Array<string | { asin?: string }>;
}

export interface ProductPairingLogItemApi {
    id: string;
    matchId?: string;
    createTime?: string;
    operateTime?: string;
    createdAt?: string;
    operatorName?: string;
    operator?: string;
    action?: string;
    actionLabel?: string;
    systemWarehouseName?: string;
    /** 接口已拼好的展示文案，优先使用 */
    beforeText?: string;
    afterText?: string;
    beforeJson?: ProductPairingLogSnapshotApi | null;
    afterJson?: ProductPairingLogSnapshotApi | null;
}

export interface ProductPairingLogRow {
    id: string;
    operateTime: string;
    operatorName: string;
    actionLabel: string;
    systemWarehouseName: string;
    beforeText: string;
    afterText: string;
}

function normalizeAsins(value?: Array<string | { asin?: string }> | string): string[] {
    if (!value) return [];
    if (typeof value === "string") {
        return value
            .split(/[,，、]/)
            .map(s => s.trim())
            .filter(Boolean);
    }
    return value
        .map(item => (typeof item === "string" ? item : item.asin || ""))
        .map(s => s.trim())
        .filter(Boolean);
}

function formatPairingSnapshot(snapshot?: ProductPairingLogSnapshotApi | null): string {
    if (!snapshot) return "-";
    const sku = (snapshot.sku1p || snapshot.skulp || "").trim();
    const asinList = normalizeAsins(snapshot.asins);
    if (!sku && !asinList.length) return "-";
    const lines: string[] = [];
    if (sku) lines.push(`1PSKU: ${sku}`);
    if (asinList.length) lines.push(`ASIN: ${asinList.join("、")}`);
    return lines.join("\n") || "-";
}

function resolveSnapshotText(directText: string | undefined, snapshot?: ProductPairingLogSnapshotApi | null): string {
    const text = (directText || "").trim();
    if (text && text !== "-") return text;
    return formatPairingSnapshot(snapshot);
}

export function mapProductPairingLogItem(item: ProductPairingLogItemApi): ProductPairingLogRow {
    return {
        id: item.id,
        operateTime: item.createTime || item.operateTime || item.createdAt || "--",
        operatorName: item.operatorName || item.operator || "--",
        actionLabel: item.actionLabel || item.action || "--",
        systemWarehouseName: item.systemWarehouseName || "--",
        beforeText: resolveSnapshotText(item.beforeText, item.beforeJson),
        afterText: resolveSnapshotText(item.afterText, item.afterJson),
    };
}

export function buildPairingLogDialogTitle(warehouseSku: string): string {
    return t(`【${warehouseSku || "--"}】的配对日志`);
}
